define('views/modules/member/group/edit/group-edit-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/user',
    'services/events/user-events',
    // views
    'src/views/form-view',
    'views/parts/menu/menu-save-action',
    'views/parts/tree/tree-view',
    'views/parts/menu/menu-dropdown',
    'views/parts/alert/alert-list',
    'views/modules/member/group/edit/group-edit-form',
    'views/modules/member/group/group-lists-controller',
    // templates
    'text!templates/modules/member/group/edit/group-edit-content.html',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    User,
    UserEvents,
    // views
    VForm,
    VMenuSaveAction,
    VTreeView,
    VMenuDropdown,
    VAlertList,
    VGroupEditForm,
    VGroupListsController,
    // templates
    TGroupEditContent
) {

    var VGroupEditContent = VForm.extend({
        template: TGroupEditContent,

        regions: {
            root: "#group-edit-content",
            menu: ".menu-actions",
            alert: ".alert-list",
            groups: "#group-menu",
            forms: {
                group: ".group-edit-form",
            },
        },

        initialize: function(options) {
            this.selectedGroup = options.selectedGroup;

            this.view = {
                menu: new VMenuSaveAction({
                    context: this,
                    onClick: this.onActionClick,
                    onSave: this.onSaveButton,
                    radio: false,
                    saveText: 'supervisor:member-edit-save-button',
                    tooltip: { container: this.regions.root, }
                }),
                forms: {
                  group: new VGroupEditForm({
                    model: this.model,
                    selectedGroup: this.selectedGroup,
                    collection: this.collection,
                  }),
                },
                alert: new VAlertList({
                    collection: new Backbone.Collection([])
                })
            };

            this.listenTo(this.model, { 'change': this.onModelChange });
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.menu, zone.$menu)
                .assign(view.alert, zone.$alert)
                .assign(view.forms.group, zone.forms.$group);

            return this;
        },

        ////////////
        // events //
        ////////////
        onGroupCollectionUpdate: function() {
            if (!this.selectedGroup) {
                this.onSelectGroup(this.collection.at(0));
            } else {
                this.onSelectGroup(this.selectedGroup);
            }
        },

        onSelectGroup: function(groupModel) {
            var selectedGroup = this.selectedGroup;
            if (groupModel !== undefined && selectedGroup !== groupModel) {
                if (selectedGroup) {
                    selectedGroup.set('_menuActive', false);
                }

                this.selectedGroup = selectedGroup = groupModel;
            }

            this.view.groups.setLabel(selectedGroup.get('name'));
            this.model.setGroup(groupModel);
            selectedGroup.set('_menuActive', true);
        },

        onActionClick: function(e) {
            e.preventDefault();
        },

        onModelChange: function() {
            this.view.menu.toggleSaveButton(!this.isDirty());
        },

        onSaveButton: function() {
            this.model.set("name", this.view.forms.group.view.form.name.getInputValue());

            //If this group is NOT a root group, we can set is parent group
            if (!this.model.isTopLevelFirstGroup())
                this.model.set("parent", User.get('_mainGroupId'));

            this.submit();
        },

        onSuccess: function() {
            //this.trigger('group:edit', this.model);
            UserEvents.groupModify(this.model);
            this.trigger('back');
        },

        onError: function(response) {
            if (response && response.responseJSON) {
              var errorCode = response.responseJSON.code,
                  message = response.responseJSON.message;

              if (errorCode) {
                this.view.alert.reset();
                this.view.alert.addError("api-messages:" + errorCode.replace(/_/g, '-'));
              }
            }

        },

        onSubmit: function() {
            var model = this.model;
        },

    });

    return VGroupEditContent;
});

